export default __webpack_public_path__ + "static/profile-two-8c87c3dfe4a6a95c34ef91b9e9180820.png";